import React, { useState } from 'react'
import { Box, Button, IconButton } from '@mui/material'

import { SbpPayment } from '../../types.ts'
import { Icon } from '../icon.tsx'

import { RefundDialog } from './refund-dialog.tsx'
import { useUser } from '@/stores/slices/user-slice.ts'

export const RefundSbpButton = ({
  canBeReversed,
  availableForReverse,
  operationId,
  qrcType,
  iconButton = true,
  type,
}: SbpPayment & { iconButton?: boolean }): React.ReactElement => {
  const user = useUser()
  const [showRefund, setShowRefund] = useState(false)
  const handleTogglePopup = (visible: boolean) => () => setShowRefund(visible)

  const isDisabled = user?.accessType !== 'FULL' || !canBeReversed || type === 'INCOME_B2B'
  const isStaticQr = qrcType === '01'

  return (
    <Box
      onClick={(event) => event.stopPropagation()}
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {iconButton ? (
        <IconButton color="primary" onClick={handleTogglePopup(true)} disabled={isDisabled}>
          <Icon name="ArrowBack" />
        </IconButton>
      ) : (
        <Button onClick={handleTogglePopup(true)} size="medium" disabled={isDisabled}>
          Сделать возврат
        </Button>
      )}
      {showRefund && (
        <RefundDialog
          availableForReverse={availableForReverse}
          operationId={operationId}
          isStaticQr={isStaticQr}
          onClose={handleTogglePopup(false)}
        />
      )}
    </Box>
  )
}
